<form *ngIf="!selelectCompany" [formGroup]='loginForm' (ngSubmit)='loginForm.valid?onSubmit($event):errorMsg()'>
  <div class='container-login' >

    <div class='login-content mat-elevation-z6' >

      <div>
        <h1 style='text-align: center;'>Inicia sesión</h1>
      </div>

      <div class='item'>
        <mat-form-field>
          <input type="text" matInput formControlName='user' placeholder="Usuario" required>
        </mat-form-field>
      </div>

      <div class='item'>
        <mat-form-field>
          <input [type]="hide ? 'password' : 'text'" matInput formControlName='password' placeholder="Contraseña"
            required>
          <div class="hide-button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </div>
        </mat-form-field>
      </div>

      <div class='item'>
        <button type='submit' class='log mat-elevation-z5' mat-raised-button color='warn'>Ingresar</button>
      </div>


    </div>
  </div>
</form>


<div *ngIf="selelectCompany">
  <div class="w-100 d-flex justify-content-end p-3">
    <button mat-mini-fab color="primary" (click)='selelectCompany = false'>
      <mat-icon>reply</mat-icon>
    </button>
  </div>

  <div class="container-select-company" >
    <div style="padding: 5vh 5vh 0 5vh;" *ngFor="let compania of companias">
      <div class="img-background icon mat-elevation-z4"
        [ngStyle]="{ 'background-image': 'url(' + baseUrl + compania.companyLogo + '/' + 0 +')'}"
        (click)="handleClick($event, compania)">
        <div>
        </div>
      </div>
      <div class="icon-title">
        <h3>{{ compania.companyName | slice: 0: 21 }}{{ compania.companyName.length > 21 ? '...' : ''}}</h3>
      </div>
    </div>
  </div>
</div>
